import { motion } from "framer-motion";
import { ArrowRightLeft, ArrowUpRight } from "lucide-react";
import { EASE } from "./Reveal";

const links = [
  { label: "Vision", href: "#vision" },
  { label: "Manifeste", href: "#manifeste" },
  { label: "Simulation", href: "#simulation" },
  { label: "FAQ", href: "#faq" },
];

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#070C0A]/70 border-b border-emerald-400/10"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <span className="w-9 h-9 rounded-xl bg-emerald-400 grid place-items-center text-[#070C0A] transition-transform duration-300 group-hover:rotate-6">
            <ArrowRightLeft className="w-4.5 h-4.5" strokeWidth={2.5} />
          </span>
          <span className="leading-none">
            <span className="block font-display font-bold text-lg tracking-tight">Alternativ</span>
            <span className="block text-[9px] font-jbmono uppercase tracking-[0.28em] text-emerald-400/80">Courtage Énergie</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8" data-testid="nav-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-slate-400 hover:text-emerald-300 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="https://candidature.alternativ-france.fr/dossier"
          data-testid="nav-apply-button"
          className="group inline-flex items-center gap-2 rounded-full bg-emerald-400 text-[#070C0A] pl-5 pr-4 py-2.5 text-sm font-semibold transition-all duration-300 hover:bg-emerald-300 hover:shadow-[0_0_28px_rgba(52,211,153,0.45)]"
        >
          Postuler
          <span className="font-jbmono text-[10px] bg-[#070C0A]/15 rounded-full px-2 py-0.5">7 places</span>
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </motion.header>
  );
}
